// The press-and-hold that names a game-menu tab (R2214; mockup round 102
// card 15; ui-map-interface.md §12.0 "The tab bar"). A glyph tab carries no
// word on a telephone, so a finger that rests on a tab for `tab_hold_ms`
// shows the full word in a bubble over the bar, or beside the cell on the
// rail, and the tab does NOT open. A shorter touch opens the tab at its
// release. A mouse keeps the press rule of fixed chrome (R237) and the
// `title` of the tab names it on a hover; a keyboard focus shows the same
// bubble through the stylesheet (`:focus-visible`).
//
// The bubble is the class `bub` on the held tab: the stylesheet draws the
// word of its `aria-label` in it, so no node is built and none is left
// behind when the bar is rewritten.

import { pressedControl } from './pressroute';
import { installHold } from './hold';
import { TAB_GLYPH } from '../gen/presentation';

/** The class of a tab whose bubble stands. */
export const BUBBLE_CLASS = 'bub';

/**
 * Takes the touch and pen presses on the six game tabs of `host` away from
 * the dispatcher of the bar: a hold of `holdMs` shows the bubble, and a
 * shorter press calls `press` with the tab at its release. A press the
 * browser cancels does nothing.
 */
export function installTabHold(
  host: HTMLElement, press: (tab: HTMLButtonElement) => void, holdMs: number = TAB_GLYPH.holdMs,
): void {
  installHold(host, {
    pick: (ev) => (ev.pointerType === 'touch' || ev.pointerType === 'pen'
      ? pressedControl<HTMLButtonElement>(ev, 'button[data-act="tab"]') : null),
    hold: (tab) => { tab.classList.add(BUBBLE_CLASS); },
    end: (tab) => { tab.classList.remove(BUBBLE_CLASS); },
    press,
  }, holdMs);
}
